"use strict";
exports.__esModule = true;
exports.memoize = void 0;
var uri_1 = require("../util/uri");
function memoize(retrieve) {
    var cache = {};
    return function (uri) {
        var normalizedURI = (0, uri_1.normalizeURI)(uri);
        var cached = cache[normalizedURI];
        if (cached) {
            return cached;
        }
        var document = retrieve(uri);
        cache[normalizedURI] = document;
        return document;
    };
}
exports.memoize = memoize;
